import { useState } from 'react'
import styled from 'styled-components'

import Spin from 'pared/components/basicUi/spin'
import { FE2_BASE_URL } from 'pared/constants'
import { MOBILE_WIDTH } from 'pared/constants/styles'
import { getSeededFe2CustomerCode, hasFe2SeedFailed } from 'pared/utils/user'

export interface IPropsType {
  type: 'FE V2'
  configPath: string
  width?: string
  height?: string
}

const Iframe = styled.iframe<{ $width?: string; $height?: string }>`
  width: ${(props) => props.$width || 'calc(100vw - 350px);'};
  height: ${(props) => props.$height || 'calc(100vh - 190px)'};
  border: 0px;

  @media ${MOBILE_WIDTH} {
    width: 100vw;
    height: calc(100vh - 80px);
  }
`

const ReSignInPrompt = styled.div`
  padding: 60px 20px;
  text-align: center;
  font-size: 16px;
`

const FeV2 = ({ configPath, width, height, ...props }: IPropsType) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const [isLoaded, setIsLoad] = useState(false)
  const fe2BaseUrl = FE2_BASE_URL
  // why: expo authorizes an iframe page by the session's customer code
  // matching the path's first segment - build the path from the same code
  // the session was seeded with. configPath's own first segment is the
  // production FE2 code and carries neither the _staging__ prefix nor any
  // per-deployment override.
  const [, ...configPathRest] = configPath.split('/')
  const fe2ConfigPath = [getSeededFe2CustomerCode(), ...configPathRest].join(
    '/',
  )

  // why: when the FE2.0 session could not be seeded (e.g. magic-link sign-in
  // has no password to seed with), the iframe would render a bare 401 - tell
  // the user how to fix it instead.
  if (hasFe2SeedFailed())
    return (
      <ReSignInPrompt>
        Please sign out and sign back in with your email and password to view
        this page.
      </ReSignInPrompt>
    )

  return (
    <Spin spinning={!isLoaded}>
      <Iframe
        {...props}
        src={`${fe2BaseUrl}/${fe2ConfigPath}?isInIframe=true&timezone=${timezone}`}
        $width={width}
        $height={height}
        onLoad={() => setIsLoad(true)}
      />
    </Spin>
  )
}

export default FeV2
